import script from "./Like.vue?vue&type=script&setup=true&lang=ts"
export * from "./Like.vue?vue&type=script&setup=true&lang=ts"

import "./Like.vue?vue&type=style&index=0&id=28274605&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28274605"]])

export default __exports__